var imgArray = [];
let index = 0;
const totalImages = 9;
let img = document.getElementById('carousel');

for (var i = 1; i <= totalImages; i++) {
  imgArray.push(sampleWagiesDir + '0' + i + '.jpg');
}

function autoChange() {
  if (index >= imgArray.length) {
    index = 0;
  }
  img.src = imgArray[index];
  index++;
  setTimeout(autoChange, 1000);
}

autoChange();
